import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=c09ac3aa&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=c09ac3aa&prod&lang=css&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&id=c09ac3aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09ac3aa",
  null
  
)

export default component.exports